import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./NavBar.css";
import { RiMenu5Fill } from "react-icons/ri";
import { RiCloseLine } from "react-icons/ri";

const NavBar = () => {
  const [showHamburger, setShowHamburger] = useState(false);

  const handleClick = () => setShowHamburger(!showHamburger);

  return (
    <>
      <nav className="navBar">
        <img src="./bird-logo.jpg" alt="bird logo" className="logoNav" />
        <p className="myName">LeontineC</p>
        <button className="button" onClick={handleClick}>
          {showHamburger ? (
            <RiCloseLine className="RiClose" />
          ) : (
            <RiMenu5Fill className="RiMenu" />
          )}
        </button>
        <ul className="navLinks" id={showHamburger ? "hidden" : ""}>
          <li className="navItem">
            <NavLink exact activeClassName="active" to="/" className="navLink" onClick={handleClick}>
              Home
            </NavLink>
          </li>
          <li className="navItem">
            <NavLink activeClassName="active" to="/about" className="navLink" onClick={handleClick}>
              Who I Am
              </NavLink>
          </li>
          <li className="navItem">
          <NavLink activeClassName="active" to="/contact" className="navLink" onClick={handleClick}>
              Get in Touch
              </NavLink>
          </li>
          <li className="navItem">
          <NavLink activeClassName="active" to="/projects" className="navLink" onClick={handleClick}>
              Projects
              </NavLink>
          </li>
         
        </ul>
      </nav>
    </>
  );
};

export default NavBar;
